import React from 'react';
import { defineMessages, useIntl } from 'react-intl-next';

import EditIcon from '@atlaskit/icon/core/migration/edit';
import WatchIcon from '@atlaskit/icon/core/migration/eye-open--watch';

import type { ModeOption } from './ModeSwitcher';
import { ModeSwitcher } from './ModeSwitcher';
import { i18n as i18nToggle } from './LivePagesModeToggle';

export type LivePageModes = 'edit' | 'view';
export interface LivePagesModeSwitcherProps {
	selectedMode: LivePageModes;
	onChange?: (value: LivePageModes) => void;
	isDisabled?: boolean;
}

const i18n = defineMessages({
	viewingText: {
		id: 'editor-main-buttons.live-pages-mode-switcher.viewing.label',
		defaultMessage: 'Viewing',
		description:
			'Text that informs a user that they are in a viewing only state of the page and edits can not be made',
	},
});

export const LivePagesModeSwitcher = ({
	selectedMode,
	onChange,
	isDisabled,
}: LivePagesModeSwitcherProps) => {
	const intl = useIntl();

	const options: ModeOption[] = [
		{
			value: 'edit',
			icon: <EditIcon label="" testId="live-pages-mode-edit-icon" />,
			label: intl.formatMessage(i18nToggle.editingText),
		},
		{
			value: 'view',
			icon: <WatchIcon label="" testId="live-pages-mode-view-icon" />,
			label: intl.formatMessage(i18n.viewingText),
		},
	];

	const handleModeChange = (value: string) => onChange?.(value as LivePageModes);

	return (
		<ModeSwitcher
			selectedValue={selectedMode}
			options={options}
			onChange={handleModeChange}
			isDisabled={isDisabled}
			label={intl.formatMessage(i18nToggle.modeSwitcherLabel)}
		/>
	);
};
